import { useMemo } from 'react';

import type { PinData } from '../../Map.types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Returns a memoized not minimized pins.
 */
export const useNotMinimizedPins = (pins: PinData[] | readonly PinData[]) => {
  return useMemo(() => pins.filter(checkIfPinIsNotMinimized), [pins]);
};

// ─── Utils ───────────────────────────────────────────────────────────────────

function checkIfPinIsNotMinimized(pin: PinData) {
  return !pin.isMinimized;
}
